import { render, staticRenderFns } from "./MyNotifications.vue?vue&type=template&id=9fb55aec"
import script from "./MyNotifications.vue?vue&type=script&lang=js"
export * from "./MyNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports